import { addCouponError, createUnionId, getPageName, addUserInfoError, addCustomError } from '@mtfe/sweet-report';
import store from '../store';

const { storeCommon } = store;

export const createTags = async () => {
    const phone = storeCommon.phone;
    const pageName = getPageName();
    const unionId = createUnionId(pageName, { phone });

    return {
        phone,
        unionId,
    };
};

export const addCouponErrorToReport = async (errorMsg) => {
    const tags = await createTags();
    addCouponError(errorMsg, tags);
};

export const addUserInfoErrorToReport = async (errorMsg) => {
    const tags = await createTags();
    addUserInfoError(errorMsg, tags);
};

export const addPageError = async (errorMsg) => {
    const tags = await createTags();
    addCustomError(errorMsg, tags);
};
